import { Dispatch, FormEvent, SetStateAction, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import InputSelect from "../../../../../components/Input-select";
import { toastError, toastSuccess, toastWarn } from "../../../../../components/Toast";
import useAuthData from "../../../../../hook/useAppData";
import { CreateProjectUsers, INeedModalDelete } from "../../../model";
import { service } from "../../../service/service";

const STATUSLIST = [
  { id: 1, label: "Cancelado" },
  { id: 2, label: "Concluído" },
];

const STATUS_LIST_VALUE = {
  1: "Cancelado",
  2: "Concluído",
};

interface IInactiveProjectUsers extends CreateProjectUsers {
  is_deleted?: boolean;
}

interface IModalDelete {
  needModalDelete: INeedModalDelete;
  setNeedModalDelete: Dispatch<SetStateAction<INeedModalDelete>>;
  setNameModal: Dispatch<SetStateAction<string>>;
  getProjectsApi: () => void;
}

export function ModalDelete({ needModalDelete, setNeedModalDelete, setNameModal, getProjectsApi }: IModalDelete) {
  const { token } = useAuthData();
  const [defaultValues, setDefaultValues] = useState<CreateProjectUsers>();
  const [valueSelect, setValueSelect] = useState<number>(0);

  useEffect(() => {
    getProjectById();
  }, []);

  async function getProjectById() {
    const projectById: { project: CreateProjectUsers } = await service.getByIdProjects(String(needModalDelete?.id), token);
    setDefaultValues(projectById?.project);
    setNameModal(projectById?.project?.name);
  }

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    if (!valueSelect) return toastWarn("É necessário selecionar o status do projeto");
    const data: IInactiveProjectUsers = {
      ...defaultValues,
      status: STATUS_LIST_VALUE[valueSelect],
      is_deleted: true,
      isDeleted: true,
    };
    const bodyReqFile = { body: JSON.stringify(data), file: undefined };
    const res = await service.putProjects(bodyReqFile, String(needModalDelete.id), token);
    verefyRes(res, data);
  }

  function verefyRes(res: { ok: boolean }, data: CreateProjectUsers) {
    if (!res?.ok) return toastError(`não foi possivel ${data?.status === "Cancelado" ? "cancelar" : "concluir"} esse projeto!`);
    toastSuccess(`${data?.name} foi ${data?.status} com sucesso!`);
    getProjectsApi();
    return setTimeout(() => handleExitClick(), 2000);
  }

  function handleExitClick() {
    setNeedModalDelete({ status: false, id: 0 });
  }

  const formClassNames = {
    form: "form-delete-project box-form min-height-none modalPopUpBodyContainer",
    divButton: "box-button-delete-project btnContainer justify-center width-100",
  };

  return (
    <>
      <Toaster />
      <form onSubmit={handleSubmit} className={formClassNames.form}>
        <InputSelect
          className="inputContainer"
          name="status"
          label="Status do projeto"
          placeholder="Selecione o Status do Projeto"
          value={valueSelect}
          onChange={(event) => setValueSelect(+event.target.value)}
          list={STATUSLIST}
        />
        <div className={formClassNames.divButton}>
          <button type="submit" className="btn filter-btn bg-primary">
            Salvar
          </button>
          <button className="Link btn bg-secondary" onClick={() => handleExitClick()}>
            Cancelar
          </button>
        </div>
      </form>
    </>
  );
}
